<h1>Maintenance</h1>
<div class="row">
  <div class="col-md-8">
    @if (maintenanceDataSort() && maintenanceDataSort()!.length > 0) {
      @for (mainItem of maintenanceDataSort(); track mainItem.SerialNumber) {
        <mat-accordion>
          <mat-expansion-panel style="margin-bottom: 8px" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if (mainItem.Title && mainItem.SerialNumber) {
                  {{ mainItem.Title }}, Serial number: {{ mainItem.SerialNumber }}
                } @else {
                  Components
                }
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (mainItem.MainUser) {
              Main user: {{ mainItem.MainUser }}
            }
            <table class="table table-hover table-stacked table-striped">
              <colgroup>
                <col />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
              </colgroup>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Item ID</th>
                  <th>Hardware Warranty expiry date</th>
                  <th>Software Maintenance expiry date</th>
                </tr>
              </thead>
              <tbody>
                @for (childItem of getSortedComponents(mainItem.Components); track $index) {
                  <tr>
                    <td class="col-Description">
                      @if (childItem.IsMainComponent) {
                        <span>System</span>
                      } @else {
                        <span>{{ childItem.Description }}</span>
                      }
                    </td>
                    <td class="itemIds">{{ childItem.ItemIds }}</td>
                    <td [ngClass]="getDateCssClass(childItem.HardwareWarrantyExpiryDate, 'Hardware')">
                      {{ childItem.HardwareWarrantyExpiryDate ? (childItem.HardwareWarrantyExpiryDate | date: "dd/MMM/yyyy") : "-" }}
                    </td>
                    <td [ngClass]="getDateCssClass(childItem.SoftwareWarrantyExpiryDate, 'Software')">
                      {{ childItem.SoftwareWarrantyExpiryDate ? (childItem.SoftwareWarrantyExpiryDate | date: "dd/MMM/yyyy") : "-" }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        </mat-accordion>
      }
    } @else {
      <p>No maintenance data available.</p>
    }
  </div>
  <div class="col-md-4">
    <app-renewal [listOfSerialNr]="getValidSerialNumbers()"> </app-renewal>
  </div>
</div>
